import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './lang/en.json';
import ru from './lang/ru.json';
import et from './lang/et.json';
import lt from './lang/lt.json';
import lv from './lang/lv.json';
import { themeConfig } from 'configs/theme.config';

const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
  et: {
    translation: et,
  },
  lt: {
    translation: lt,
  },
  lv: {
    translation: lv,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: themeConfig.locale,
  lng: themeConfig.locale,
  interpolation: {
    escapeValue: false,
  },
});

export const dateLocales = {
  en: () => import('dayjs/locale/en'),
  lv: () => import('dayjs/locale/lv'),
  lt: () => import('dayjs/locale/lt'),
  et: () => import('dayjs/locale/et'),
  ru: () => import('dayjs/locale/ru'),
};

export default i18n;
